import styled from 'styled-components'

import { Button, type ButtonProps } from '@blade/ui-kit'

type WalletsDialogButtonProps = {} & ButtonProps

export const WalletsDialogButton: React.FC<WalletsDialogButtonProps> = (
  props,
) => {
  return (
    <Root>
      <Button
        size="h36"
        variant="solid"
        color="primary"
        fullWidth
        radius="rounded"
        {...props}
      />
    </Root>
  )
}

const Root = styled.div`
  padding-inline: 10px;
  padding-block: 6px 10px;
`
